import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { getPathPrefix, getTenantSlug, isTenantScopedMiniappPath } from './routing';

interface TenantContextValue {
  tenantSlug: string;
  pathPrefix: string;
  tenantPathPrefix: string;
  isTenantScoped: boolean;
}

const TenantContext = createContext<TenantContextValue | null>(null);

interface TenantProviderProps {
  children: ReactNode;
}

export function TenantProvider({ children }: TenantProviderProps) {
  const value = useMemo<TenantContextValue>(() => {
    const pathPrefix = getPathPrefix();
    const isTenantScoped = isTenantScopedMiniappPath();
    const tenantSlug = getTenantSlug();

    return {
      tenantSlug,
      pathPrefix,
      tenantPathPrefix: pathPrefix,
      isTenantScoped,
    };
  }, []);

  return <TenantContext value={value}>{children}</TenantContext>;
}

export function useTenant(): TenantContextValue {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }

  return context;
}
